export default __webpack_public_path__ + "static/media/profile_placeholder.845a2383.png";